export default "__VITE_ASSET__snVPIdGV__"